// Mock data for Comments

export const MOCK_COMMENTS = [
  {
    id: 'comment-001',
    moduleId: 'm1',
    moduleName: 'Production trends',
    author: {
      id: 'user-001',
      name: 'Dr. Marco Rossi',
      email: 'marco.rossi@example.com',
      role: 'reviewer',
      avatar: null,
    },
    text: 'The production data looks good. However, I noticed a slight discrepancy in the June figures. Can we verify this?',
    timestamp: new Date('2024-11-20T10:30:00'),
    replies: [
      {
        id: 'comment-001-reply-001',
        moduleId: 'm1',
        author: {
          id: 'user-002',
          name: 'Admin User',
          email: 'admin@example.com',
          role: 'admin',
          avatar: null,
        },
        text: 'I\'ve verified the June data. The discrepancy was due to a late harvest entry. All figures are correct.',
        timestamp: new Date('2024-11-20T11:15:00'),
        replies: [],
        resolved: false,
      },
    ],
    resolved: false,
    resolvedBy: null,
    resolvedAt: null,
  },
  {
    id: 'comment-002',
    moduleId: 'm3',
    moduleName: 'Water savings',
    author: {
      id: 'user-002',
      name: 'Admin User',
      email: 'admin@example.com',
      role: 'admin',
      avatar: null,
    },
    text: 'Water consumption is within acceptable limits. Good work on the efficiency improvements.',
    timestamp: new Date('2024-11-21T09:00:00'),
    replies: [],
    resolved: true,
    resolvedBy: 'Dr. Marco Rossi',
    resolvedAt: new Date('2024-11-21T10:00:00'),
  },
  {
    id: 'comment-003',
    moduleId: 'm4',
    moduleName: 'Microclimate',
    author: {
      id: 'user-001',
      name: 'Dr. Marco Rossi',
      email: 'marco.rossi@example.com',
      role: 'reviewer',
      avatar: null,
    },
    text: 'The microclimate data shows excellent conditions. The agrivoltaic system is performing as expected.',
    timestamp: new Date('2024-11-22T14:20:00'),
    replies: [],
    resolved: false,
    resolvedBy: null,
    resolvedAt: null,
  },
];

// Helper function to get comments by module
export function getCommentsByModule(comments, moduleId) {
  if (!moduleId || moduleId === 'all') {
    return comments;
  }
  return comments.filter(comment => comment.moduleId === moduleId);
}

// Helper function to format comment timestamp
export function formatCommentTime(date) {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  const days = Math.floor(seconds / 86400);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}


